import { useEffect, useState } from "react";
// @mui material components
import Card from "@mui/material/Card";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
// Acromegaly React components
import MDBox from "components/MDBox";
import Swal from "sweetalert2";
import LoadingOverlay from "react-loading-overlay";
// Acromegaly React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import { styled } from "@mui/material/styles";
// Acromegaly React contexts
import { NavLink, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  TextField,
  Tooltip,
} from "@mui/material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import TablePaginationActions from "examples/Tables/TablePaginationActions";
import getText from "Translator";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { displayErrorMessage } from "controllers/validation";
import {
  getCapsules,
  updateCapsuleRowNumbers,
  deleteCapsule,
  editCapsules,
} from "controllers/MenuController";
import { displaySuccessMessage } from "controllers/validation";
import { submitCapsule } from "controllers/MenuController";
import { getUsersList } from "controllers/UserController";
import { deleteUser } from "controllers/UserController";
import { useMaterialUIController } from "context";
import NewPatientComponent from "views/components/NewPatientComponent";
import { getUsersFilesWithCapsule } from "controllers/FileController";
import { getForms } from "controllers/MenuController";
import { updateFileFiller } from "controllers/FileController";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  td: {
    height: 42,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

let editId;
function OutUsers(props) {
  const [controller] = useMaterialUIController();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [datas, setDatas] = useState([]);
  const [formDatas, setFormDatas] = useState([]);
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [mode, setMode] = useState("new");
  const [search, setSearch] = useState("");
  const [count, setCount] = useState(0);
  const [fillFromName, setFillFromName] = useState("");
  const [fillFromMobile, setFillFromMobile] = useState("");
  const [fillFromPages, setFillFromPages] = useState([]);
  const [reload, setReload] = useState(new Date());

  const { title, headline, capsule, capsuletitle } = useParams();

  const navigate = useNavigate();

  const handleDeleteClick = (id) => {
    Swal.fire({
      text: getText("deleteconfirm", controller.lang),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: getText("confirmButtonText", controller.lang),
      cancelButtonText: getText("cancel", controller.lang),
    }).then(async (result) => {
      if (result.value) {
        setLoading(true);
        let data = await deleteUser({ id }, controller);
        setLoading(false);
        if (data.success) {
          displaySuccessMessage(
            controller.lang,
            getText("deletesuccessful", controller.lang)
          );

          getData(rowsPerPage, page + 1, search);
        } else {
          if (data.errorCode === 101) {
            navigate("/authentication/sign-in", { replace: true });
          } else {
            displayErrorMessage(controller.lang, data.message, data.code);
          }
        }
        setLoading(false);
      }
    });
  };
  const getFormsData = async () => {
    try {
      let newData = {
        lang: "fa",
        capsule,
      };

      let data = await getForms(controller.lang, newData, controller.token);

      if (data.success) {
        console.log("data.data", data.data);
        if (data.data) setFormDatas(data.data[0].pages);
      } else {
        displayErrorMessage(controller.lang, data.message, data.code);
      }
    } catch (err) {
      console.log(err);
      displayErrorMessage(controller.lang);
    }
  };
  const storeFiller = async () => {
    try {
      let newData = {
        lang: "fa",
        file: editId,
        fillFromName,
        fillFromMobile,
        fillFromPages: JSON.stringify(fillFromPages),
      };
      console.log(newData);
      let result = await updateFileFiller(newData, controller);

      if (result.success) {
        console.log("data.data", result.data);
        setMode("");
        setOpen(false);
        setFillFromName("");
        displaySuccessMessage(controller.lang, result.message);
      } else {
        displayErrorMessage(controller.lang, result.message, result.code);
      }
    } catch (err) {
      console.log(err);
      displayErrorMessage(controller.lang);
    }
  };
  const handleClose = () => {
    setOpen(false);
    setMode("new");
    setText("");
  };
  const searchHandler = (serachParam) => {
    console.log("serachParam", serachParam);
    getData(rowsPerPage, page + 1, serachParam);
  };

  const addFormFillterReder = () => {
    return (
      <>
        <Grid container style={{ marginTop: 15, marginBottom: 20 }} spacing={2}>
          <Grid item xs={6} sm={6} md={6}>
            {/* {patientExist+"asdasdas"} */}
            <b>نام پرکننده فرم *</b>
            <br />
            <TextField
              key="FillFromName"
              id="FillFromName"
              fullWidth={true}
              variant="outlined"
              onChange={(event) => {
                let text = event.target.value;
                setFillFromName(text);
              }}
              value={fillFromName}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <b>شماره موبایل پرکننده *</b>
            <br />
            <TextField
              key="fillFromMobile"
              id="fillFromMobile"
              fullWidth={true}
              variant="outlined"
              onChange={(event) => {
                let text = event.target.value;
                setFillFromMobile(text);
              }}
              value={fillFromMobile}
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12} sm={12} md={12}>
            <div className={"listmenu rtl"}>
              <List id="mainlist" key={`mainlist`}>
                {formDatas &&
                  formDatas.map((item, index) => (
                    <>
                      <ListItem
                        style={{
                          height: 40,
                          cursor: "pointer",
                        }}
                        key={"btnx" + index}
                        button
                      >
                        <Checkbox
                          checked={
                            fillFromPages.filter((a) => a + "" == item.id + "")
                              .length > 0
                              ? true
                              : false
                          }
                          onChange={() => {
                            let temp = fillFromPages;
                            let exist = fillFromPages.filter(
                              (a) => a + "" == item.id + ""
                            );
                            if (exist.length > 0) {
                              temp = fillFromPages.filter(
                                (a) => a + "" !== item.id + ""
                              );
                              setFillFromPages(temp);
                            } else {
                              temp.push(item.id);
                              setFillFromPages(temp);
                            }
                            setReload(new Date());
                          }}
                          size="larg"
                        />

                        <ListItemText
                          onClick={() => {
                            // menuClickHandler(item, false);
                          }}
                        >
                          <div>{item.text}</div>
                        </ListItemText>
                      </ListItem>
                    </>
                  ))}
              </List>
            </div>
          </Grid>
          <Grid container>
            <Grid item xs={12} sm={12} md={12}>
              <Button
              fullWidth
              
                onClick={() => {
                  storeFiller();
                }}
              >
                ثبت
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getData(rowsPerPage, newPage + 1, search);
  };
  const handleDropRows = (droppedItem) => {
    // Ignore drop outside droppable container
    if (!droppedItem.destination) return;
    var updatedList = [...datas];
    // Remove dragged item
    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
    // Add dropped item
    updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
    // Update State
    updatedList.map((item, index) => {
      item.rownumber = rowsPerPage * page + index + 1;
    });
    updateCapsuleRowNumbers(controller.lang, updatedList, controller.token);
    setDatas(updatedList);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    getData(parseInt(event.target.value, 10), 1, search);
  };
  useEffect(() => {
    if (!controller.authenticated) {
      navigate("/authentication/sign-in", { replace: true });
      return;
    }

    getData(rowsPerPage, 1, "");
    getFormsData();
  }, []);
  const getData = async (rowsPerPagex, pagex, searchx) => {
    try {
      setLoading(true);
      let newData = {
        capsule,
        search,
        fileMenuType: "capsule",
      };

      let data = await getUsersFilesWithCapsule(newData, controller);

      setLoading(false);
      if (data.success) {
        console.log(data.data);
        setDatas(data.data);
        setCount(data.count);
      } else {
        displayErrorMessage(controller.lang, data.message, data.code);
      }
    } catch (err) {
      console.log(err);
      displayErrorMessage(controller.lang);
    }
  };
  return (
    <DashboardLayout>
      <DashboardNavbar
        title={`کاربران: ${capsuletitle}`}
        searchHandler={searchHandler}
        showserch={true}
      />
      <MDBox pb={3}>
        <Card>
          <MDBox>
            <LoadingOverlay
              active={loading}
              spinner
              text={getText("loading", controller.lang)}
            >
              <Button
                style={{ float: "left" }}
                onClick={() => {
                  setMode("new");
                  setOpen(true);
                }}
              >
                ثبت پرونده جدید
              </Button>
              <TableContainer>
                <Table size="larg" sx={{ minWidth: 600 }}>
                  <TableBody>
                    <TableRow style={{ backgroundColor: "#ccc" }}>
                      <TableCell>{getText("name", controller.lang)}</TableCell>
                      <TableCell>کدملی</TableCell>
                      <TableCell>پرکننده فرم</TableCell>{" "}
                      <TableCell>موبایل پرکننده فرم</TableCell>
                      <TableCell
                        align="center"
                        style={{ width: 110 }}
                      ></TableCell>
                    </TableRow>

                    {datas.map((row, index) => (
                      <StyledTableRow
                        key={row._id}
                        style={{
                          backgroundColor: index % 2 === 0 ? "#fff" : "#f2f2f2",
                        }}
                      >
                        <TableCell>{row.text}</TableCell>
                        <TableCell>{row.nationalCode}</TableCell>
                        <TableCell>{row.fillFromName}</TableCell>
                        <TableCell>{row.fillFromMobile}</TableCell>

                        <TableCell align="center">
                          <div>
                            <Tooltip
                              title={"تعریف پر کننده فرم ها"}
                              aria-label="edit"
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              <PersonAddAltIcon
                                style={{ width: 20, height: 20 }}
                                color="secondary"
                                onClick={() => {
                                  editId = row.id;
                                  setMode("fill");
                                  setFillFromMobile(row.fillFromMobile);
                                  setFillFromName(row.fillFromName);
                                  setOpen(true);
                                  setFillFromPages([]);
                                  if (row.fillFromPages) {
                                    console.log(JSON.parse(row.fillFromPages));
                                    setFillFromPages(
                                      JSON.parse(row.fillFromPages)
                                    );
                                  }
                                }}
                              />
                            </Tooltip>
                          </div>
                        </TableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[
                          5,
                          10,
                          25,
                          { label: "All", value: count },
                        ]}
                        colSpan={5}
                        count={count}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        SelectProps={{
                          inputProps: {
                            "aria-label": "Rows per page",
                          },
                          native: true,
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </LoadingOverlay>
          </MDBox>
        </Card>
      </MDBox>
      <Dialog
        open={open}
        //onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {mode === "new"
            ? " ثبت پرونده جدید"
            : "ثبت فرم ها برای کاربر خارج از سیستم"}
          <HighlightOffIcon
            style={{
              width: 20,
              height: 20,
              float: controller.direction == "rtl" ? "left" : "right",
            }}
            color="primary"
            onClick={() => {
              handleClose();
            }}
          />
        </DialogTitle>
        <DialogContent>
          {mode == "new" && (
            <NewPatientComponent
              from="file"
              capsule={capsule}
              headline={headline}
              title={title}
              closeHandle={handleClose}
              getData={getData}
            />
          )}

          {mode == "fill" && addFormFillterReder()}
        </DialogContent>
        {/* <DialogActions>
          <Button
            onClick={handleClose}
            color="secondary"
            style={{ float: "right", minWidth: 120 }}
          >
            {getText("cancel", controller.lang)}
          </Button>
          <Button active onClick={submitCapsuleHandler} color="primary">
            {mode === "new"
              ? getText("submit", controller.lang)
              : getText("edit", controller.lang)}
          </Button>
        </DialogActions> */}
      </Dialog>
    </DashboardLayout>
  );
}

export default OutUsers;
